import { useFlyOutProductsBasedOnSelectedCloud } from '../../common/utils/hooks/useFlyOutProductsBasedOnSelectedCloud'
import { useParams } from 'react-router-dom'
import {
  SelectedCloudIcon,
  useCurrentCloudProvider,
  useAccountId,
  LayoutWrapper,
} from '@labrav/common'
import { useDispatch } from '../../store'
import type { Product } from '../../modules/productsListing/types'
import { useEffect, type ComponentType, type ReactNode } from 'react'
import { isEmpty } from 'lodash'
import { getProducts } from '../../modules/productsListing/action'
import { ShortenedName } from '../../common/components/ShortenedName/ShortenedName'
import { ContractListing } from './ContractListing'
import { useStyles } from './ContractListingWrapper.styles'
import { useTheme } from '@mui/material/styles'
import { useSyncFlyoutRouteParams } from '../../common/utils/hooks/useSyncFlyoutRouteParams'

export const ContractListingWrapper = ({
}) => {
  useSyncFlyoutRouteParams()

  const { classes } = useStyles()
  const theme = useTheme()
  const dispatch = useDispatch()
  const cloudMarketplace = useCurrentCloudProvider()

  const {
    accountId: routeAccountId,
    productId,
    secureKey,
  } = useParams<{
    cloud: string
    accountId: string
    productId: string
    secureKey?: string
  }>()
  const fallbackAccountId = useAccountId({ product: 'flyout' }) || ''
  const accountId = routeAccountId || fallbackAccountId
  const { products } = useFlyOutProductsBasedOnSelectedCloud()
  const product =
    products.find(item => item.productId === productId) || ({} as Product)

  useEffect(() => {
    if (!isEmpty(accountId)) {
      if (!secureKey && isEmpty(product)) {
        dispatch(getProducts(accountId, cloudMarketplace))
      }
    }
  }, [accountId])

  return (
    <div data-testid="contract-listing-wrapper">
      <LayoutWrapper
        title={
          <>
            <div className={classes.headerContainer}>
              <span>Create metering:</span>
              <div className={classes.headerInnerContainer}>
                <ShortenedName
                  name={product.productName || ''}
                  length={30}
                  tooltipPlacement="right-end"
                  isV2={true}
                />
              </div>
            </div>
          </>
        }
        isBack={true}
        isSidePanelOpened={false}
        component={ContractListing}
        actions={SelectedCloudIcon}
        bgColor={theme.palette.labraV2BoxShadow.dark}
      />
    </div>
  )
}
